// Constants
import { STORAGE_KEYS } from '../constants/storage';

export function initAuthentication() {
    const { ACCESS_TOKEN } = STORAGE_KEYS;
    let accessToken = sessionStorage.getItem(ACCESS_TOKEN);
    if (!accessToken) {
        accessToken = localStorage.getItem(ACCESS_TOKEN);
    }
    if (accessToken) {
        sessionStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken);
        return accessToken;
    }
    return null;
}

export function getAuthentication() {
    const { ACCESS_TOKEN } = STORAGE_KEYS;
    const accessToken = sessionStorage.getItem(ACCESS_TOKEN);
    return accessToken ? accessToken : null;
}

export function setAuthentication(accessToken: string, remember: boolean) {
    sessionStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken);
    if (remember) {
        localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken);
    }
    return true;
}

export function deleteAuthentication() {
    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    sessionStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);

    return true;
}

export function checkIfRemembered() {
    return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN) !== null;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utilities/auth.ts